// ---------------------------------
// Our code
export default [
  // {
  //   to: "/",
  //   text: "Dashboard",
  //   tooltip: "Dashboard"
  // },
  {
    icon: "mdi-view-dashboard",
    text: "Harry Potter",
    children: [
      {
        to: "/app/death_eaters_rising",
        icon: "computer",
        text: "Death eaters rising",
        tooltip: "Dice/Cards game"
      }
    ]
  },
  {
    icon: "mdi-view-dashboard",
    text: "Word games",
    children: [
      {
        to: "/app/termbank/TermMaster",
        icon: "computer",
        text: "TermMaster",
        tooltip: "Help Nicomachus become a TermMaster"
      },
      {
        to: "/app/mwebank/MweMaster",
        icon: "computer",
        text: "MweMaster",
        tooltip: "Help Nicomachus become a MweMaster by finding multiword expressions"
      },
      {
        to: "/app/mwebank/MweHunter",
        icon: "computer",
        text: "MweHunter",
        tooltip: "Help Nicomachus become a MweHunter by finding meanings for MWEs"
      }
    ]
  }

  // {
  //   icon: "mdi-view-storage",
  //   text: "Databases",
  //   children: [
  //     {
  //       to: "/app/dbtrainer",
  //       icon: "computer",
  //       text: "DB Trainer",
  //       tooltip: "Execute simple SQL queries"
  //     }
  //   ]
  // },
  // {
  //   icon: "storage",
  //   text: "Data science",
  //   children: [
  //     {
  //       to: "/app/tfidf",
  //       icon: "computer",
  //       text: "TF/IDF (Syspro 2018)",
  //       tooltip: "Calculate TF/IDF for Syspro 2018 assignment"
  //     }
  //   ]
  // },
  // {
  //   icon: "computer",
  //   text: "Operating systems",
  //   children: [
  //     {
  //       to: "/app/os/disk_scheduling",
  //       icon: "computer",
  //       text: "Disk scheduling",
  //       tooltip: "Solve and visualize disc scheduling algorithms"
  //     },
  //     {
  //       to: "/app/os/page_replacement",
  //       icon: "computer",
  //       text: "Page replacement",
  //       tooltip: "Solve and visualize page replacement scheduling algorithms"
  //     },
  //     {
  //       to: "/app/os/process_scheduling",
  //       icon: "computer",
  //       text: "Process scheduling",
  //       tooltip: "Solve and visualize process scheduling algorithms"
  //     }
  //   ]
  // },
  // {
  //   icon: "cloud",
  //   text: "Networking",
  //   children: [
  //     {
  //       to: "/app/networking/basics",
  //       icon: "computer",
  //       text: "Networking basics",
  //       tooltip: "Solve simple subnetting cases"
  //     }
  //   ]
  // },
  // {
  //   icon: "mdi-clipboard-outline",
  //   text: "Parallel systems",
  //   children: [
  //     {
  //       to: "/app/parallel_systems/mpi",
  //       icon: "computer",
  //       text: "MPI",
  //       tooltip: "Visualize MPI data structures"
  //     }
  //   ]
  // },
  // {
  //   icon: "mdi-table-edit",
  //   text: "Other",
  //   children: [
  //     {
  //       to: "/app/other/lean",
  //       icon: "computer",
  //       text: "LEAN system",
  //       tooltip: "Calculate BMR and TDEE (based on Tom Venuto bibliography)"
  //     }
  //   ]
  // }
];
